<template>
  <section class="back-to-shop">
    <p role="timer" aria-atomic="true">{{ $t('confirmation.linkBackTimeout') }} {{redirectTime}} {{ $t('confirmation.linkBackTimeoutTime') }}</p>
    <button type="button"
            ref="backButton"
            class="btn button-back-to-shop"
            :title="$t('confirmation.linkBack')"
            @click="goBackToShop">
      {{ $t('confirmation.linkBack') }}
    </button>
    <input type="hidden" style="margin: 10px;" id="iframefocus" value="">
  </section>
</template>

<script>
import { mapState } from 'vuex'
import { ToolsClass } from '@/base/class/tools.class'
import { MobileAppClass } from '@/base/class/mobileApp.class'
import redirectTimerMixin from '@/base/mixins/redirectTimer.mixin'

export default {
  name: 'PaywayErrorButton',
  mixins: [redirectTimerMixin],
  computed: {
    ...mapState({
      returnUrl: state => state.payment.paymentData.returnUrl || ''
    })
  },
  methods: {
    goBackToShop () {
      this.stopRedirectTimeout()
      if (ToolsClass.isMobileAppConnection()) {
        MobileAppClass.callMobileTransactionFinish()
        return
      }
      ToolsClass.goToExternalUrl(this.returnUrl)
    }
  },
  mounted () {
    this.initRedirectTimer()
  },
  beforeDestroy () {
    this.destroyRedirectTimer()
  }
}
</script>
